import { Component, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import AOS from 'aos';

@Component({
  selector: 'app-whitepaper-cover',
  imports: [CommonModule],
  standalone: true,
  templateUrl: './whitepaper-cover.component.html',
  styleUrl: './whitepaper-cover.component.scss'
})
export class WhitepaperCoverComponent implements AfterViewInit {
  constructor(private router: Router) { }

  ngAfterViewInit() {
    // Timeout ensures DOM is rendered before AOS calculates positions
    setTimeout(() => {
      AOS.init();
      AOS.refresh();
    }, 1000);
  }

  nav(url: any) {
    this.router.navigateByUrl(url)
  }

  whitePapers: any[] =
    [
       {
        img: '../../../../assets/resources/whitepaper/autonomous-machine-revolution/autonomous-machine-revolution-cover-card.png',
        route: '/kalpita-white-papers/autonomous-machine-revolution',
        title: 'Autonomous Machine Revolution & Rise of Machine Agency - 2026'
      },
      {
        img: '../../../../assets/resources/whitepaper/rise-of-ai-agent/rise-of-ai-agent.webp',
        route: '/kalpita-white-papers/rise-of-ai-agent',
        title: ' The Rise of AI Agents in Enterprise Automation'
      },
      {
        img: '../../../../assets/resources/whitepaper/agentic-ai-in-sdlc/agentic-ai-in-sdlc.webp',
        route: '/kalpita-white-papers/agentic-ai-in-sdlc',
        title: 'Agentic AI in the SDLC'
      },
      {
        img: '../../../../assets/resources/whitepaper/it-trends/it-trends.webp',
        route: '/kalpita-white-papers/it-trends',
        title: ' IT Trends 2025-2030'
      },
      {
        img: '../../../../assets/resources/whitepaper/designpatterns/introToDesignPatterns.png',
        route: '/kalpita-white-papers/intro-design-patterns',
        title: ' Introduction to Design Patterns'
      },
      {
        img: '../../../../assets/resources/whitepaper/creationaldesignpattern/CreationalDesignPattern.webp',
        route: '/kalpita-white-papers/creational-design-patterns',
        title: 'Creational Design Pattern'
      },
      {
        img: '../../../../assets/resources/whitepaper/structuraldesignpattern/StructuralDesignPattern.webp',
        route: '/kalpita-white-papers/structural-design-patterns',
        title: ' Structural Design Pattern'
      },
      {
        img: '../../../../assets/resources/whitepaper/behaviouraldesignpattern/Behavioural_Design_Pattern.webp',
        route: '/kalpita-white-papers/behavioural-design-patterns',
        title: ' Behavioural Design Pattern'
      },
      {
        img: '../../../../assets/resources/whitepaper/eseeticketbooking/esee-ticket.webp',
        route: '/kalpita-white-papers/onlinemovie-ticket-booking',
        title: 'Whitepaper on Online Movie Ticket Booking'
      },
      {
        img: '../../../../assets/resources/whitepaper/seatlayoutTicketbooking/SeatLayoutWorkflow.webp',
        route: '/kalpita-white-papers/seatlayout-workflow',
        title: 'Whitepaper on Seat Layout Workflow for Movie Ticket Booking Mobile App'
      }
    ]
}